import { render } from "./EntriesEdit.vue?vue&type=template&id=58f8b39c&scoped=true"
import script from "./EntriesEdit.vue?vue&type=script&lang=js"
export * from "./EntriesEdit.vue?vue&type=script&lang=js"

import "./EntriesEdit.vue?vue&type=style&index=0&id=58f8b39c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58f8b39c"

export default script